import { render, staticRenderFns } from "./OrderCg.vue?vue&type=template&id=307076ab&scoped=true"
import script from "./OrderCg.vue?vue&type=script&lang=js"
export * from "./OrderCg.vue?vue&type=script&lang=js"
import style0 from "./OrderCg.vue?vue&type=style&index=0&id=307076ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307076ab",
  null
  
)

export default component.exports